import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

// Initialize Clarity
function initializeClarity() {
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "scnbpo5jyr");
}

// Check if app is installed (running in standalone mode)
function isAppInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         ('standalone' in window.navigator && window.navigator.standalone === true) ||
         document.referrer.includes('android-app://');
}

// Reset install prompt tracking for non-installed devices
function resetInstallPromptTracking() {
  if (!isAppInstalled()) {
    localStorage.removeItem('installPromptShown');
    localStorage.removeItem('installPromptDismissed');
    serviceWorkerRegistration.unregister();
  }
}

// Force service worker update check
async function forceUpdateCheck() {
  if (!navigator.serviceWorker) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      await registration.update();
      if (registration.waiting && isAppInstalled()) {
        window.dispatchEvent(new CustomEvent('openUpdatePrompt', { detail: { registration } }));
      }
    }
  } catch (error) {
    console.error('Error during forced update check:', error);
  }
}

// Start update checker
function startUpdateChecker() {
  let updateInterval;

  const checkUpdates = () => {
    if (!document.hidden) {
      forceUpdateCheck();
    }
  };

  // Check immediately
  setTimeout(checkUpdates, 1000);

  // Check every 30 seconds while app is active
  updateInterval = setInterval(checkUpdates, 30000);

  // Check when app becomes visible or focused
  const visibilityOrFocusHandler = () => {
    if (!document.hidden) {
      setTimeout(checkUpdates, 1000);
    }
  };

  document.addEventListener('visibilitychange', visibilityOrFocusHandler);
  window.addEventListener('focus', visibilityOrFocusHandler);

  // Cleanup on unload
  window.addEventListener('beforeunload', () => clearInterval(updateInterval));
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (isAppInstalled()) {
      window.dispatchEvent(new CustomEvent('openUpdatePrompt', { detail: { registration } }));
    }
  },
  onInstallPrompt: () => {
    // No automatic dispatch - prompt only triggered by TopNav button
  },
});

// Handle page load
window.addEventListener('load', () => {
  // Check for manual service worker unregistration
  if (new URLSearchParams(window.location.search).get('reset-sw') === 'true') {
    serviceWorkerRegistration.unregister();
  }

  // Reset tracking for non-installed devices
  resetInstallPromptTracking();

  // Initialize Clarity and start update checker
  initializeClarity();
  startUpdateChecker();
});

// Handle service worker updates
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  if (navigator.serviceWorker.controller) {
    initializeClarity(); // Re-initialize Clarity
  }
});

// Listen for messages from service worker
navigator.serviceWorker?.addEventListener('message', (event) => {
  if (event.data?.type === 'UPDATE_AVAILABLE' && isAppInstalled()) {
    window.dispatchEvent(new CustomEvent('openUpdate perniciouslyPrompt', { detail: { registration: event.data.registration } }));
  }
});

reportWebVitals();